// ============================================================================
// CANCUN100 — ModalError.js  (Bloque 27: un solo modal de error para todos los formularios)
// ----------------------------------------------------------------------------
// Se muestra ENCIMA del formulario sin cerrarlo ni vaciarlo. Botones:
//   · Reintentar          → vuelve a ejecutar exactamente lo mismo (error.reintentar)
//   · Generar PDF de nuevo → el registro ya se guardó y solo falló el PDF (error.regenerarPdf); mismo folio
//   · Cerrar              → deja el formulario como estaba
// error = { titulo, mensaje, detalle, reintentar?, regenerarPdf?, ocupado? }
// El mensaje va en español claro; `detalle` (texto técnico de Supabase) va chico debajo, para Marco.
// ============================================================================
import React from 'react';
import { RADIO, RADIO_TARJETA } from './tema';

export default function ModalError({ C, error, onCerrar }) {
  if (!error) return null;
  const ocupado = !!error.ocupado;
  const btn = (extra) => ({ height: 40, boxSizing: 'border-box', padding: '0 16px', fontSize: 14, fontWeight: 700, borderRadius: RADIO, cursor: ocupado ? 'wait' : 'pointer', fontFamily: 'var(--au-font-text)', border: `1px solid ${C.border}`, background: 'transparent', color: C.text, ...extra });
  return (
    <div role="alertdialog" aria-modal="true" aria-labelledby="c100-error-titulo" onClick={() => !ocupado && onCerrar()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', zIndex: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, backdropFilter: 'blur(6px)' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: C.card || C.surface || C.dark, border: `1px solid ${C.red || C.rosa}66`, borderRadius: RADIO_TARJETA, boxShadow: 'var(--au-shadow-card)', width: '100%', maxWidth: 440, padding: 20, fontFamily: 'var(--au-font-text)' }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
          <div aria-hidden="true" style={{ fontSize: 22, lineHeight: 1 }}>⚠️</div>
          <div style={{ flex: 1 }}>
            <div id="c100-error-titulo" style={{ fontSize: 14, fontWeight: 700, color: C.text }}>{error.titulo || 'Algo falló'}</div>
            <div style={{ fontSize: 14, color: C.text, marginTop: 6, lineHeight: 1.5 }}>{error.mensaje}</div>
            {error.detalle && <div style={{ fontSize: 12, color: C.muted, marginTop: 8, wordBreak: 'break-word' }}>{String(error.detalle)}</div>}
            {ocupado && <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>⏳ Trabajando…</div>}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap', marginTop: 16 }}>
          <button type="button" disabled={ocupado} onClick={onCerrar} style={btn({ color: C.muted })}>Cerrar</button>
          {error.reintentar && (
            <button type="button" disabled={ocupado} onClick={error.reintentar} style={btn({ background: 'var(--equipo-grad)', color: '#fff', border: '1px solid transparent' })}>Reintentar</button>
          )}
          {error.regenerarPdf && (
            <button type="button" disabled={ocupado} onClick={error.regenerarPdf} style={btn({ background: 'var(--equipo-grad)', color: '#fff', border: '1px solid transparent' })}>Generar PDF de nuevo</button>
          )}
        </div>
      </div>
    </div>
  );
}
